import React from 'react';
import { connect } from 'react-redux';
import SymbioticMarkerClusterer from "./../devices/Components/SymbioticMarkerClusterer";
import data from './location.json';
import { highlightNavigatedMenu } from "util/highlightSidebarOption";
import {
    getDeviceCatalogue,
    getNodeVitals,
    alertsModificationData,
} from "util/aws-manager";
import _ from "lodash";

class App extends React.Component {
    currentPath;
    constructor(props) {
        super(props);
        this.state = {
            deviceLocation: data,
            eptTotal: [],
            revTotal: [],
            eptInactive: [],
            revInactive: [],
            revOpenAlert: [],
            eptOpenAlert: [],
        }

    }

    componentDidMount() {
        let revTotal = [], eptTotal = [], eptInactive = [], revInactive = [], revOpenAlert = [], eptOpenAlert = []
        getDeviceCatalogue(this.props.deviceId)
            .then((data) => {
                getNodeVitals()
                    .then((nodeResult) => {
                        let item = [...data, ...nodeResult];
                        item.push(nodeResult);
                        eptInactive = item.filter((items) => {
                            return (items.status === "INACTIVE") && items.nodeId.includes('ept-nbn');
                        })
                        revInactive = item.filter((items) => {
                            return (items.status === "INACTIVE") && items.nodeId.includes('rev-nbn');
                        })
                        let filterEptInactive = _.uniqBy(eptInactive, 'nodeId');
                        let filterRevInactive = _.uniqBy(revInactive, 'nodeId');
                        this.setState({
                            eptInactive: filterEptInactive,
                            revInactive: filterRevInactive,
                        })
                    })
                    .catch((error) => {
                        console.log('error: ', error);
                    })
                revTotal = data.filter((item) => {
                    return (item.status === "ACTIVE" || item.status === "INACTIVE") && item.nodeId.includes('rev-nbn');
                })
                eptTotal = data.filter((item) => {
                    return (item.status === "ACTIVE" || item.status === "INACTIVE") && item.nodeId.includes('ept-nbn');
                })
                this.setState({
                    eptTotal,
                    revTotal
                })
            })
            .catch((error) => {
                console.log('error: ', error);
            })
        alertsModificationData()
            .then((data) => {
                revOpenAlert = data.filter((item) => {
                    return (item.alertStatus === "Open") && item.nodeId.includes('rev-nbn');
                })
                eptOpenAlert = data.filter((item) => {
                    return (item.alertStatus === "Open") && item.nodeId.includes('ept-nbn');
                })
                let filterRev = _.uniqBy(revOpenAlert, 'nodeId');
                let filterEpt = _.uniqBy(eptOpenAlert, 'nodeId');
                this.setState({
                    revOpenAlert: filterRev,
                    eptOpenAlert: filterEpt,
                })

            })
            .catch((error) => {
                console.log('error: ', error);
            })
        this.currentPath = this.props.location.pathname;
    }

    componentWillMount() {
        this.unlisten = this.props.history.listen((location) => {
            this.currentPath = location.pathname;
        });
    }

    navigateToCataologue = (isTrue, isInactive, deviceType) => {
        if (
            !(
                (this.currentPath === "/app/components/heartbeat" ||
                    this.currentPath === "/app/components/notifications") || isTrue
            )
        ) {
            highlightNavigatedMenu("deviceCatalogue", `#${this.currentPath}`);
            this.props.history.push("/app/components/deviceCatalogue");
            let data = [{
                condition: {
                    type: 'contains',
                    key: 'contains',
                },
                key: { id: 'nodeId', numeric: false, disablePadding: true, label: 'Device ID', type: 'string' },
                value: deviceType,
            }];
            if (isInactive) {
                data.push({
                    condition: { type: "is equals", key: "equal" },
                    key:
                        { id: 'status', numeric: false, disablePadding: false, label: 'Active Indicator', type: 'string' },
                    value: "INACTIVE",
                })
            }
            this.props.addDeviceCatalogueFilter(data);
        }
        else {
            highlightNavigatedMenu("heartbeat", `#${this.currentPath}`);
            this.props.history.push("/app/components/heartbeat");
        }
    }
    navigateToAlertsPage = (deviceType) => {
        if (
            !(
                (this.currentPath === "/app/components/heartbeat" ||
                    this.currentPath === "/app/components/notifications")
            )
        ) {
            highlightNavigatedMenu("alerts", `#${this.currentPath}`);
            this.props.history.push("/app/components/alerts");
            let data = [{
                condition: { type: "is equals", key: "equal" },
                key: {
                    disablePadding: false,
                    id: "alertStatus",
                    label: "Alert Status",
                    numeric: false,
                    type: "string",
                },
                value: "Open",
            }, {
                condition: {
                    type: 'contains',
                    key: 'contains',
                  },
                key: { id: 'nodeId', numeric: false, disablePadding: true, label: 'Device ID', type: 'string' },
                value: deviceType,
            }];
            this.props.addAlert(data);
        }
    }

    renderGraph = () => {
        return (
            <div className="col-12 col-xl-12 col-lg-12 col-sm-12 col-xs-12 h-100 pl-0 ml-0 pr-3">
                <SymbioticMarkerClusterer
                    navigate={(deviceId) => {
                        this.props.updateDeviceId(deviceId);
                        this.navigateToCataologue(true);
                    }}
                    markerData={this.state.deviceLocation}
                    onBoundsChanged={(bounds) => { }}
                />
            </div>)
    }

    render() {
        return (
            <div id="landing-screen" className="contentOuter-wrapper row">
                <div className="col-12">
                    <div className="jr-card d-sm-flex justify-content-sm-between align-items-sm-center">
                        <div onClick={() => {
                            console.log("Test");
                        }} className="col-12 col-sm-12 col-lg-12">
                            <h1 className="mb-0">Summary</h1>
                        </div>
                    </div>
                </div>

                <h1 className="mx-4 my-3">ePITome DEVICES</h1>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 row">
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4" onClick={() => {
                        this.navigateToCataologue(false, false, 'ept-nbn');
                    }}>
                        <div className="jr-card" >
                            <div className="jr-card-header ">
                                <h3 className="text-black text-center">Total Devices</h3>
                            </div>
                            <div className="jr-card-body contentInner-wrapper">
                                <div className="col-12 text-center caption-outer">
                                    <h1> {this.state.eptTotal.length} </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                        <div className="jr-card" onClick={() => {
                            this.navigateToCataologue(false, true, 'ept-nbn');
                        }}>
                            <div className="jr-card-header ">
                                <h3 className="text-black text-center">Inactive Devices</h3>
                            </div>
                            <div className="jr-card-body contentInner-wrapper">
                                <div className="col-12 text-center caption-outer">
                                    <h1> {this.state.eptInactive.length} </h1>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                        <div className="jr-card" onClick={() => {
                            this.navigateToAlertsPage('ept-nbn')
                        }}>
                            <div className="jr-card-header ">
                                <h3 className="text-black text-center">Devices with Open Alerts</h3>
                            </div>
                            <div className="jr-card-body contentInner-wrapper">
                                <div className="col-12 text-center caption-outer">
                                    <h1> {this.state.eptOpenAlert.length} </h1>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <h1 className="mx-4 my-3">reVOLT DEVICES</h1>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 row">
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                        <div className="jr-card" onClick={() => {
                            this.navigateToCataologue(false, false, 'rev-nbn');
                        }}>
                            <div className="jr-card-header ">
                                <h3 className="text-black text-center">Total Devices</h3>
                            </div>
                            <div className="jr-card-body contentInner-wrapper">
                                <div className="col-12 text-center caption-outer">
                                    <h1> {this.state.revTotal.length} </h1>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                        <div className="jr-card" onClick={() => {
                            this.navigateToCataologue(false, true, 'rev-nbn');
                        }}>
                            <div className="jr-card-header ">
                                <h3 className="text-black text-center">Inactive Devices</h3>
                            </div>
                            <div className="jr-card-body contentInner-wrapper">
                                <div className="col-12 text-center caption-outer">
                                    <h1> {this.state.revInactive.length} </h1>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                        <div className="jr-card" onClick={() => {
                            this.navigateToAlertsPage('rev-nbn')
                        }}>
                            <div className="jr-card-header ">
                                <h3 className="text-black text-center">Devices with Open Alerts</h3>
                            </div>
                            <div className="jr-card-body contentInner-wrapper">
                                <div className="col-12 text-center caption-outer">
                                    <h1> {this.state.revOpenAlert.length}  </h1>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    {this.renderGraph()}
                </div>
            </div>
        );
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        updateDeviceId: (id) => {
            dispatch({ type: "UPDATE_DEVICE_ID", deviceId: id });
        },
        showLoader: () => {
            dispatch({ type: 'SHOW_OVERALL_APP_LOADER' });
        },
        hideLoader: () => {
            dispatch({
                type: 'HIDE_OVERALL_APP_LOADER'
            });
        },
        addAlert: (data) => {
            dispatch({
                type: 'ALERT_FILTER',
                alertFilter: data
            });
        },
        addDeviceCatalogueFilter: (data) => {
            dispatch({
                type: 'DEVICE_CATALOGUE_FILTER',
                deviceCatalogueFilters: data
            });
        }
    }
};

export default connect(null, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./app/routes/landingPage/index.js